import Cancellation24Hours from '../src/Cancellation24Hours/index';
export default Cancellation24Hours;
